import {
	enrichAdTagWithUserTargeting,
	configurePlayerPreRollAds,
} from '../utils/brightcove-ad-targeting';

const onReady =
	typeof window !== 'undefined' &&
	window.hmUtils &&
	typeof window.hmUtils.onDomContentLoad === 'function'
		? window.hmUtils.onDomContentLoad
		: function (callback) {
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', callback);
			} else {
				callback();
			}
		  };

const initDefaultVideoPlayers = function () {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}

	window.dataLayer = window.dataLayer || [];

	const playerElements = document.querySelectorAll(
		'.vjs-video-container video-js, video-js#hmWordpressBlockPlayer',
	);

	playerElements.forEach((playerElement) => {
		if (typeof videojs !== 'undefined' && !playerElement.dataset.hmDefaultPlayerInit) {
			playerElement.dataset.hmDefaultPlayerInit = '1';
			const playerInstance = videojs(playerElement);
			configurePlayerPreRollAds(playerInstance, playerElement);

			playerInstance.ready(function () {
				const myPlayer = this;
				configurePlayerPreRollAds(myPlayer, playerElement);

				let playEventLogged = false;

				myPlayer.on('playing', function () {
					const isAudio = playerElement
						.closest('.wp-block-hm-brightcove-with-tracking')
						?.classList.contains('is-audio');
					const playerEvent = isAudio ? 'audio_start' : 'video_start';

					if (!playEventLogged) {
						const videoTitle = myPlayer.mediainfo?.name;
						const playerId = myPlayer.bcinfo?.playerId;
						const videoId = myPlayer.mediainfo?.id;

						window.dataLayer.push({
							event: playerEvent,
							videoTitle: videoTitle,
							playerId: playerId,
							videoId: videoId,
						});
						playEventLogged = true;
					}
				});
			});
		}
	});
};

if (typeof document !== 'undefined' && document.readyState !== 'loading') {
	initDefaultVideoPlayers();
}
onReady(initDefaultVideoPlayers);

if (typeof module !== 'undefined' && module.exports) {
	module.exports = {
		enrichAdTagWithUserTargeting,
		configurePlayerPreRollAds,
	};
}
